export default __webpack_public_path__ + "static/media/apply-leave-enabled.41d8c063.svg";